module.exports = __webpack_public_path__ + "static/media/office_8.30d967c1.jpg";